module.exports = __webpack_public_path__ + "media/images/plans/ceremony/og-image-134936f64ee3224813359706b3f775d2.jpg";